import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Termini() {
  return (
    <div className="min-h-screen bg-brand-bg" data-testid="termini-page">
      <header className="border-b border-brand-line bg-white/60 backdrop-blur-sm sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-brand-inkSoft hover:text-brand-ink transition" data-testid="termini-back">
            <ArrowLeft className="w-4 h-4" />
            <span className="text-sm">Indietro</span>
          </Link>
          <span className="font-heading text-lg text-brand-ink">24Vox</span>
          <div className="w-16"></div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-16">
        <p className="text-xs font-medium tracking-[0.25em] text-brand-terra uppercase mb-4">Condizioni</p>
        <h1 className="font-heading text-4xl md:text-5xl text-brand-ink mb-2">Termini di Servizio</h1>
        <p className="text-brand-inkSoft mb-12">Ultimo aggiornamento: febbraio 2026</p>

        <div className="space-y-8 text-brand-ink leading-relaxed">
          <section>
            <h2 className="font-heading text-2xl mb-3">1. Cosa offriamo</h2>
            <p>24Vox è un servizio software che fornisce un assistente vocale AI personalizzato sulla tua azienda. Il servizio si rivolge esclusivamente a titolari di partita IVA con sito web aziendale.</p>
          </section>

          <section>
            <h2 className="font-heading text-2xl mb-3">2. La demo</h2>
            <p>La demo è gratuita e non vincolante. Per accedervi devi inserire un indirizzo email il cui dominio corrisponde al tuo sito web aziendale. Limitiamo a 3 demo per ora dallo stesso indirizzo IP e a 20 messaggi per sessione, per evitare abusi.</p>
          </section>

          <section>
            <h2 className="font-heading text-2xl mb-3">3. Prezzo</h2>
            <p>Il piano commerciale 24Vox prevede un abbonamento annuale di <strong>588€/anno</strong> per la piattaforma (pagamento unico, IVA esclusa). Le chiamate ricevute sono addebitate a consumo, al costo effettivo, senza ricarico, tramite un borsellino prepagato ricaricabile in qualsiasi momento. Non ci sono costi nascosti, costi di setup o canoni extra.</p>
          </section>

          <section>
            <h2 className="font-heading text-2xl mb-3">4. Garanzia 30 giorni</h2>
            <p>Se entro 30 giorni dall'attivazione del piano commerciale ritieni che il servizio non funzioni come promesso, ti restituiamo l'intero importo senza chiederti spiegazioni.</p>
          </section>

          <section>
            <h2 className="font-heading text-2xl mb-3">5. Cosa promettiamo</h2>
            <p>Ci impegniamo a mantenere il servizio operativo 24 ore su 24, 7 giorni su 7. In caso di disservizio prolungato, ti riconosciamo un'estensione del piano pari al tempo di indisponibilità.</p>
          </section>

          <section>
            <h2 className="font-heading text-2xl mb-3">6. Cosa NON promettiamo</h2>
            <p>L'AI è uno strumento, non sostituisce il tuo giudizio professionale. Non ci assumiamo responsabilità per decisioni prese dai tuoi clienti sulla base di informazioni generate dall'assistente. Per questo l'AI è istruita a non inventare prezzi, orari o servizi non confermati.</p>
          </section>

          <section>
            <h2 className="font-heading text-2xl mb-3">7. Recesso</h2>
            <p>Puoi disdire il piano in qualsiasi momento scrivendo a <a href="mailto:robs@24vox.it" className="text-brand-olive underline">robs@24vox.it</a>. Il servizio resta attivo fino alla scadenza dell'anno già pagato.</p>
          </section>

          <section>
            <h2 className="font-heading text-2xl mb-3">8. Foro competente</h2>
            <p>Per ogni controversia relativa a questi termini è competente il Foro italiano di residenza del consumatore o, se il cliente è impresa, il Foro della sede di 24Vox.</p>
          </section>
        </div>
      </main>
    </div>
  );
}
